class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink.dataset.drawer) return;
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => { this.classList.add('animate', 'active') });
  
      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.classList.remove('active');
      this.classList.remove('add-new-product')
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }
  
    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');
  
      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }
  
      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });
  
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  
    renderContents(parsedState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section) => {
        if (!section.id || !section.selector) {
          console.error(`Section ID or selector is missing in getSectionsToRender.`);
          return;
        }
    
        const sectionElement = document.querySelector(section.selector) || document.getElementById(section.id);
    
        if (sectionElement) {
          const newInnerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    
          if (newInnerHTML) {
            if (section.id === 'cart-icon-bubble') {
              const parser = new DOMParser();
              const newCartBubble = parser.parseFromString(newInnerHTML, 'text/html').querySelector('.cart-count-bubble');
              const existingCartBubble = sectionElement.querySelector('.cart-count-bubble');
    
              if (existingCartBubble && newCartBubble) {
                existingCartBubble.innerHTML = newCartBubble.innerHTML;
              } else if (newCartBubble) {
                sectionElement.appendChild(newCartBubble);
              }
            } else {
              sectionElement.innerHTML = newInnerHTML;
            }
          } else {
            console.error(`Could not find the selector ${section.selector} in the provided HTML.`);
          }
        } else {
          console.error(`Section element with ID ${section.id} or selector ${section.selector} not found.`);
        }
      });
    
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
    
  
  
  getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const element = parsedHTML.querySelector(selector);
      
      return element ? element.innerHTML : null;
  }
  
  
    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        { id: 'cart-icon-bubble', 
          selector: '#cart-icon-bubble'
        },
      ];
    }
  
    getSectionDOM(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  class CartDrawerItems extends CartItems {
    onCartUpdate() {
      fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => response.json())
        .then((sections) => {
          const cartDrawerMarkup = sections['cart-drawer'];
          if (cartDrawerMarkup) {
            const updatedDrawer = new DOMParser().parseFromString(cartDrawerMarkup, 'text/html');
            const currentDrawer = document.getElementById('CartDrawer');
            const nextDrawer = updatedDrawer.querySelector('#CartDrawer');

            if (currentDrawer && nextDrawer) {
              currentDrawer.innerHTML = nextDrawer.innerHTML;
            }

            const nextCartDrawer = updatedDrawer.querySelector('cart-drawer');
            const currentCartDrawer = document.querySelector('cart-drawer');
            if (currentCartDrawer && nextCartDrawer) {
              currentCartDrawer.classList.toggle('is-empty', nextCartDrawer.classList.contains('is-empty'));
            }
          }

          const cartBubbleMarkup = sections['cart-icon-bubble'];
          if (cartBubbleMarkup) {
            const updatedBubble = new DOMParser().parseFromString(cartBubbleMarkup, 'text/html');
            const currentCartBubble = document.getElementById('cart-icon-bubble');
            const nextCartBubble = updatedBubble.querySelector('.cart-count-bubble');
            const existingCartBubble = currentCartBubble?.querySelector('.cart-count-bubble');

            if (!currentCartBubble) return;

            if (existingCartBubble && nextCartBubble) {
              existingCartBubble.innerHTML = nextCartBubble.innerHTML;
            } else if (nextCartBubble) {
              currentCartBubble.insertAdjacentHTML('beforeend', nextCartBubble.outerHTML);
            } else if (existingCartBubble) {
              existingCartBubble.remove();
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }

    getSectionsToRender() {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
  }
  
  customElements.define('cart-drawer-items', CartDrawerItems);
  
